<template>

  <v-navigation-drawer
    app
    v-model="drawer"
    :expand-on-hover="true"
    permanent
    clipped
    :width="330"
  >

    <template v-slot:prepend>

      <v-list color="secondary">
        <v-list-item>
          <v-list-item-avatar>
            <v-icon class="white--text">mdi-filter</v-icon>
          </v-list-item-avatar>
          <v-list-item-title class="white--text">
            Filter Partners
          </v-list-item-title>
        </v-list-item>

      </v-list>

    </template>

    <v-list nav dense
            @mouseenter.stop="open = false"
            @mouseexit.stop="open = true"
    >

      <v-list-item>
        <v-list-item-icon>
          <v-icon>mdi-video-plus</v-icon>
        </v-list-item-icon>
        <v-list-item-title class="pl-3">
          <v-switch
            v-model="filters.video"
            label="Only Profiles w/Video"
            class="mt-2"
          ></v-switch>
        </v-list-item-title>
      </v-list-item>

      <v-divider></v-divider>

      <v-list-item>
        <v-list-item-icon>
          <v-icon>mdi-shape</v-icon>
        </v-list-item-icon>
        <v-list-item-title class="pl-3">
          <v-radio-group v-model="filters.category" hide-details label="Categories"
                         class="mt-0 drawer-list">
            <v-radio label="All" value="all"></v-radio>
            <v-radio
              v-for="n in categories"
              :key="n"
              :label="n"
              :value="n"

            ></v-radio>
          </v-radio-group>
        </v-list-item-title>
      </v-list-item>

      <v-divider></v-divider>

      <v-list-item>
        <v-list-item-icon>
          <v-icon>mdi-format-list-triangle</v-icon>
        </v-list-item-icon>
        <v-list-item-title class="pl-3">
          <v-radio-group v-model="filters.type" hide-details label="Types"
                         class="mt-0 drawer-list">
            <v-radio label="All" value="all"></v-radio>
            <v-radio
              v-for="n in types"
              :key="n"
              :label="n"
              :value="n"
            ></v-radio>
          </v-radio-group>
        </v-list-item-title>
      </v-list-item>

    </v-list>

  </v-navigation-drawer>

</template>

<script>
import sortedUniq from 'lodash/sortedUniq';
import sortBy from 'lodash/sortBy';

export default {

  name: 'DrawerPartners',

  props: {

    items: {
      type: Array,
      required: true,
    },

    search: {
      type: String,
      required: false,
      default: '',
    },

    video: {
      type: Boolean,
      required: false,
      default: false,
    },

    category: {
      type: String,
      required: false,
      default: '',
    },

    type: {
      type: String,
      required: false,
      default: '',
    },

  },

  data() {
    return {
      drawer: true,
      open: true,
      filters: {}
    };
  },

  mounted() {
    this.filters = {
      search: this.search,
      video: this.search,
      category: this.category,
      type: this.type,
    };
  },

  watch: {

    filters: {
      deep: true,
      handler(filters, oldFilters) {
        if (filters !== oldFilters) {
          this.$emit('filter-update', filters);
        }
      },
    },

  },

  computed: {

    categories() {
      return sortedUniq(sortBy(this.items.map(i => i.properties.Category)));
    },

    types() {
      return sortedUniq(sortBy(this.items.map(i => i.properties.Type)));
    },

  },

};
</script>
